import { QueryClient } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import {
  getBackofficeOrganizationQuery,
  getBackofficeOrganizationQueryKey,
} from "modules/backoffice/lib/organizations/getBackofficeOrganizationQuery"
import { Crumb } from "modules/shared/lib/breadcrumbs"
import { BackofficeOrganizationResponseDataSchema } from "schema"
import z from "zod"

function getOrganizationName(id: string, queryClient: QueryClient) {
  const organization = queryClient.getQueryData(
    getBackofficeOrganizationQueryKey({ id }),
  ) as z.infer<typeof BackofficeOrganizationResponseDataSchema>
  if (organization) return organization.name

  return queryClient
    .fetchQuery(getBackofficeOrganizationQuery({ query: { id } }))
    .then((organization) => organization.name)
}

export const Route = createFileRoute("/_base/_auth/backoffice/organizations/$id")({
  loader: async ({ context, route: { fullPath }, params }) => {
    return new Crumb({
      fullPath,
      title: getOrganizationName(params.id, context.queryClient),
    })
  },
})
